<template>
  <div class="form">
    <div class="form__question">
      <label
        class="form__label required"
        for="seedRateTargetPopulation"
      >
        <span>{{ store.calculateSeedVolume ? store.translations.ActualSeedRate : store.translations.TargetPopulation }}</span>
      </label>
      <div class="form__input-container">
          <input
            class="form__input"
            type="number"
            id="seedRateTargetPopulation"
            v-model="store.seedRateTargetPopulation"
            onkeypress="return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)"
          >
        <div class="form__unit">
          <span v-if="store.metric && store.calculateSeedVolume">{{ store.translations.Kg }}/{{ store.translations.Ha }}</span>
          <span v-else-if="store.metric && !store.calculateSeedVolume">{{ store.translations.Plants }}/{{ store.translations.M2 }}</span>
          <span v-else-if="!store.metric && store.calculateSeedVolume">{{ store.translations.Lb }}/{{ store.translations.Acres }}</span>
          <span v-else-if="!store.metric && !store.calculateSeedVolume">{{ store.translations.Plants }}/{{ store.translations.Ft2 }}</span>
        </div>
      </div>
    </div>
    <div class="form__question">
      <label
        class="form__label required"
        for="thousandGrainWeight"
      >
        <span>{{ store.translations.ThousandKernelWeight }}</span>
      </label>
      <div class="form__input-container">
        <input
          class="form__input"
          type="number"
          id="thousandGrainWeight"
          v-model="store.thousandGrainWeight"
          onkeypress="return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)"
        >
        <div class="form__unit">
          <span>{{ store.translations.Gram }}</span>
        </div>
      </div>
    </div>
    <div class="form__question">
      <label
        class="form__label required"
        for="germinationRate"
      >
        {{ store.translations.GerminationRate }}
      </label>
      <div class="form__input-container">
        <input
          class="form__input"
          type="number"
          id="germinationRate"
          v-model="store.germinationRate"
          onkeypress="return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)"
        >
        <div class="form__unit">%</div>
      </div>
    </div>
    <div class="form__question">
      <label
        class="form__label required"
        for="fieldGerminationRate"
      >
        {{ store.translations.FieldGerminationRate }}
      </label>
      <div class="form__input-container">
        <input
          class="form__input"
          type="number"
          id="fieldGerminationRate"
          v-model="store.fieldGermination"
          onkeypress="return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)"
        >
        <div class="form__unit">%</div>
      </div>
    </div>
    <div class="form__question">
      <label
        class="form__label required"
        for="fieldSize"
      >
        {{ store.translations.FieldSize }}
      </label>
      <div class="form__input-container">
        <input
          class="form__input"
          type="number"
          id="fieldSize"
          v-model.number="store.fieldSize"
          onkeypress="return event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)"
        >
        <div class="form__unit">
          <span>{{ store.metric ? store.translations.Ha : store.translations.Acres }}</span>
        </div>
      </div>
    </div>
    <div class="form__required">{{ store.translations.Required }}</div>
  </div>
</template>

<script setup>
import { useSeedRateCalculatorStore } from '../store/store.js';

const store = useSeedRateCalculatorStore();

</script>